export default __webpack_public_path__ + "static/avatar4-bad41d1fb8f0c8a776cbf9cb3ac787b7.jpg";